angular.module('account.login', ['account'])
    .config(function ($stateProvider) {
        $stateProvider.state('login', {
            parent: 'unauthenticated',
            url: '/login',
            views: {
                'content@': 'loginComponent'
            },
            resolve: {
                returnTo: (stateHandler, $transition$) => stateHandler.returnTo($transition$)
            }
        });
    });
